import { prettierBytes } from '@transloadit/prettier-bytes'

/**
 * Format byte sizes with proper handling of nullish values.
 * Returns "N/A" for null or undefined values instead of "0 B".
 * Supports numeric strings and actual numbers.
 */
export function formatBytes(input: unknown): string {
  if (input === null || input === undefined) {
    return 'N/A'
  }

  // Handle numbers directly
  if (typeof input === 'number') {
    return Number.isNaN(input) ? 'N/A' : prettierBytes(input)
  }

  // Only convert strings that actually represent numbers
  if (typeof input === 'string') {
    // Match integers, decimals (including scientific notation)
    const isNumeric = /^-?\d+(\.\d+)?([eE][-+]?\d+)?$/.test(input.trim())

    if (isNumeric) {
      const numericValue = Number(input)
      return prettierBytes(numericValue)
    }
  }

  // For all other cases (non-numeric strings, objects, etc.)
  return 'N/A'
}
